import { swatchGroupTemplate } from "../templates";
import { SwatchView } from "./swatch";

var SwatchGroupView = Backbone.View.extend({
    tagName: 'div',
    className: 'swatch-group',
    events: {
        'click a.swatch-link' : 'removeTooltip'
    },
    initialize: function(options) {
        this.options = options;
        // window.customLogger( this.options );
        _.bindAll( this, 'render', 'addSwatch', 'getSelection', 'removeTooltip', 'cleanup' );
        this.bind( 'teardown', this.cleanup );
        this._views = [];
        
        this.render();
    },
    render: function(){
        var selection = this.getSelection();
        var swatch = this.model.get('swatches').findWhere( { code: selection } );

        var sName = swatch ? swatch.get( 'name' ) : selection;
        var item = swatchGroupTemplate( { label: this.model.get( 'label' ), type: this.model.get( 'type' ), selection: sName, open: this.options.open } );
        this.el.innerHTML = item;
        // for each swatch, add the subview
        this.model.get('swatches').each( this.addSwatch );
        // add fabric com popup?
        if ( 'fabric' === this.model.get( 'type' ) ) {
					
            let message = this.options.outdoor === true ? 'Fabrics shown are for illustration only and are not suitable for outdoor use': 'These fabrics are just idea starters. For more options, see our graded-in and COM programs.';
            this.$( 'a.product-collapse-link' ).popover({
                'content' : message,
                'trigger' : 'click',
                'offset' : '0px 6px',
                'placement' : 'auto'
            });
            // this.$( 'a.product-collapse-link' ).on( 'click',  this.showTooltip );
            this.$( 'a.product-collapse-link' ).on( 'hidden.bs.popover', this.removeTooltip );
            this.$( 'a.product-collapse-link' ).on( 'blur', this.removeTooltip );
        }
    },
    removeTooltip: function( e ){
        e.preventDefault();
        
        if ( typeof this.shownTooltip === 'undefined' ) {
            this.$( 'a.product-collapse-link' ).popover( 'hide' );
            this.shownTooltip = true;
            this.$( 'a.product-collapse-link' ).popover( 'disable' );
        }
    },
    addSwatch: function( model ){
        var swatchView = new SwatchView( { 'model' : model, 'selection': this.getSelection() } );

        this._views.push( swatchView );
        this.$( '.swatches').append( swatchView.el );
    },
    getSelection: function(){
        var s = typeof this.options.selection !== 'undefined' ? this.options.selection : '';
        return s;
    },
    cleanup: function(){
        if ( !_.isEmpty( this._views ) ) {
            _.each(this._views, function(view){
                view.trigger( 'teardown' );
                view.remove();
                view.unbind();
            });
        }
        this.model.destroy();
    }
});
export { SwatchGroupView };